export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingservice) {
        element.addEventListener('click', handleClick);
        function handleClick(evt) {
            let target = evt.target;
            // In IE 10 we get an SVGElementInstance since we use <use>, so get the
            // corresponding <use> element.
            if (target.correspondingUseElement) {
                target = target.correspondingUseElement;
            }
            const closestDataTrackClickElement = target.closest(
                '[data-track-click]'
            );
            if (closestDataTrackClickElement) {
                const name = closestDataTrackClickElement.getAttribute(
                    'data-track-click'
                );
                if (name) {
                    trackingservice.deprecatedTrackEvent(name);
                }
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/dataTrackClick.js